<template>
  <Upload></Upload>
</template>
<script>
import Upload from '@/components/material-img-upload';

export default {
  name: '',
  components: {
    Upload,
  },
};
</script>
